import { filter, groupBy, maxBy } from 'lodash';
import Ivr from 'src/models/Ivrs/Ivr';

export const getPublishedIvrs = (configurations: Ivr[]) => {
  const ivrs = filter(configurations, ivr => ivr.publishedAt && !ivr.archivedAt);
  const groupedById: any = groupBy(ivrs, (item: Ivr) => item.id);

  return Object.values(groupedById).map(ivr => maxBy(ivr as any, (item: Ivr) => item.version));
};

export const getIvrsWithLatestVersion = (ivrs: any[]) => {
  const groupedById = groupBy(ivrs, item => item.id);

  Object.keys(groupedById).forEach(ivrID => {
    const ivrs = filter(groupedById[ivrID], 'publishedAt');

    if (ivrs.length) {
      const maxID = maxBy(groupedById[ivrID], item => item.version);
      const maxPublishID = maxBy(ivrs, item => item.version);

      const ivrHasChanges = maxPublishID.version !== maxID.version;

      ivrs.forEach(ivr => {
        ivr.ivrHasChanges = ivrHasChanges;
      });

      groupedById[ivrID] = ivrs;
    }
  });

  return Object.keys(groupedById).map(key => maxBy(groupedById[key], item => item.version));
};
